import { PublicKey } from '@solana/web3.js';

export const feeCollector = new PublicKey(
  'HovqYXMo4u625bqesDLF2T4dG3RR2Q8PgxuTUrbaC1VN'
);
